import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store';
import { PENDING_HAP_STATUS } from '@/types/Sixes';
import { sixCatalogAdapter } from '@/store/slices/sixCatalog/sixCatalogSlice';

export const selectCatalogState = (state: RootState) => state.sixCatalog;

const adapterSelectors = sixCatalogAdapter.getSelectors(selectCatalogState);

export const selectCatalogSixes = adapterSelectors.selectAll;

export const selectHasPendingHapSix = createSelector(
  selectCatalogSixes,
  (sixes) => sixes.some((six) => six.status === PENDING_HAP_STATUS)
);

export const selectCatalogHasLoaded = createSelector(
  selectCatalogState,
  (catalog) => catalog.hasLoaded
);

export const selectCatalogSearch = createSelector(
  selectCatalogState,
  (catalog) => catalog.search
);

export const selectCatalogFilters = createSelector(
  selectCatalogState,
  (catalogState) => catalogState.filters
);
